/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".btn-primary[_ngcontent-%COMP%]:disabled{background-color:#c7c8c8;border-color:#c7c8c9}.error[_ngcontent-%COMP%]{text-align:center;color:red}.ok[_ngcontent-%COMP%]{text-align:center}"];
export { styles as styles };
